import axios from "axios";

const API = "/api";
const TTL = 15 * 60 * 1000;

const memoryCache = new Map();

function readStorage(key) {
  const memoryValue = memoryCache.get(key);
  if (memoryValue) {
    return memoryValue;
  }

  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    memoryCache.set(key, parsed);
    return parsed;
  } catch {
    sessionStorage.removeItem(key);
    return null;
  }
}

function writeStorage(key, data) {
  const payload = { timestamp: Date.now(), data };
  memoryCache.set(key, payload);
  sessionStorage.setItem(key, JSON.stringify(payload));
}

export function getCachedPublicData(key, { allowStale = true } = {}) {
  const cached = readStorage(key);
  if (!cached) return null;

  const isFresh = Date.now() - Number(cached.timestamp || 0) < TTL;
  if (!allowStale && !isFresh) return null;

  return {
    data: Array.isArray(cached.data) ? cached.data : [],
    isFresh,
  };
}

export async function fetchAndCachePublicData(key, endpoint) {
  const response = await axios.get(`${API}${endpoint}`);
  const rows = Array.isArray(response.data) ? response.data : [];
  writeStorage(key, rows);
  return rows;
}

export function prefetchPublicData(key, endpoint) {
  const cached = getCachedPublicData(key, { allowStale: false });
  if (cached?.isFresh) {
    return Promise.resolve(cached.data);
  }

  return fetchAndCachePublicData(key, endpoint).catch(() => []);
}
